import React from 'react';
import { Link } from 'react-router-dom';
import { HowItWorksHero } from '../components/HowItWorksHero';
import { InvisibleDecisions } from '../components/InvisibleDecisions';
import { SynthiaWorkflowSection } from '../components/SynthiaWorkflowSection';
import { HowGuardrailsGetBuilt } from '../components/HowGuardrailsGetBuilt';
import { WhatSynthiaDoes } from '../components/WhatSynthiaDoes';
import { LibraryTeaserSection } from '../components/LibraryTeaserSection';
import { HowItWorksClosing } from '../components/HowItWorksClosing';
import { GuardrailExamples } from '../components/GuardrailExamples';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function HowItWorksPage() {
  return <div className="min-h-screen w-full bg-white selection:bg-[#0066FF] selection:text-white" data-id="element-2341">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2342">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2343">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2344">
            <Link to="/" data-id="element-2345">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2346" />
            </Link>
            <Navigation data-id="element-2347" />
          </div>
        </div>
      </header>

      <main data-id="element-2348">
        <HowItWorksHero data-id="element-2349" />
        <InvisibleDecisions data-id="element-2350" />
        <SynthiaWorkflowSection data-id="element-2351" />
        <HowGuardrailsGetBuilt data-id="element-2352" />
        <WhatSynthiaDoes data-id="element-2353" />
        <LibraryTeaserSection data-id="element-2354" />
        <HowItWorksClosing data-id="element-2355" />
        <GuardrailExamples data-id="element-2356" />
      </main>

      <Footer data-id="element-2357" />
    </div>;
}